// App.js
import React, { useState, useEffect } from 'react';

// <-- NOVO: Adicionar importações do react-toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { FaExpand, FaCompress } from 'react-icons/fa';
import { FaSun, FaMoon } from 'react-icons/fa';
import MinicursoManager from './components/MinicursoManager';
import './assets/styles/App.css';
import Header from './components/Header/Header';
import Navbar from './components/Navbar';
import Login from './components/Login';
import Home from './pages/Home';
import Contatos from './pages/Contatos';  
import ProfessoresDetails from './pages/ProfessoresDetails';
import ContatoDetails from './pages/ContatoDetails';
import QuestaoDetails from './pages/QuestaoDetails';
import Temas from './pages/Temas';
import Pilulas from './pages/Pilulas';
import Questoes from './pages/Questoes';
import Professores from './pages/Professores'; 
import Cursos from './pages/Cursos';  
import Relatorios from './pages/Relatorios';     
import BotControl from './components/BotControl';
import CursoDetails from './pages/CursoDetails';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Configuracao from './pages/Configuracao';
import Carregando from './components/Carregando';
import '../src/styles/main.scss';
import Administracao from './pages/Administracao.js';
import UploadLogo from './components/UploadLogo';
import Usuarios from './pages/Usuarios';
import BoletimEditor from './components/BoletimEditor';
import TreinamentoIA from './components/ia/TreinamentoIA';
import AvisoBot from './components/layout/AvisoBot';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isFullScreen, setIsFullScreen] = useState(false);  
  const [theme, setTheme] = useState('light');

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      // O painel só abre com usuário E tenantId: no primeiro acesso, o Login confere o e-mail,
      // grava o tenantId e recarrega. Sem usuário, o tenantId gravado não vale mais.
      if (!user) localStorage.removeItem('tenantId');
      setUser(user);
      setIsAuthenticated(!!user && !!localStorage.getItem('tenantId'));
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const handleFullScreen = () => {
    const elem = document.documentElement;

    if (!document.fullscreenElement) {
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
      setIsFullScreen(true);
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
      setIsFullScreen(false);
    }
  };

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    document.body.classList.remove(`${theme}-theme`);
    document.body.classList.add(`${newTheme}-theme`);
    localStorage.setItem('theme', newTheme);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.body.classList.add(`${savedTheme}-theme`);
  }, []);

  if (loading) {
    return <div className='CarregandoCentral'><Carregando/></div>;
  }

  return (
    <Router>
      <div className="App">
        {isAuthenticated ? (
          <>
            <Header 
              toggleTheme={toggleTheme} 
              theme={theme} 
              handleFullScreen={handleFullScreen} 
              isFullScreen={isFullScreen} 
            />
            
            <Navbar /> 
            <AvisoBot tenantId={localStorage.getItem('tenantId')} />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/relatorios" element={<Relatorios />} />
              <Route path="/contatos" element={<Contatos />} />
              <Route path="/contatos/:id" element={<ContatoDetails />} /> 
              <Route path="/professores/:id" element={<ProfessoresDetails />} /> 
              <Route path="/questoes/:id" element={<QuestaoDetails />} />
              <Route path="/questoes" element={<Questoes />} />       
              <Route path="/pilulas" element={<Pilulas />} />
              <Route path="/professores" element={<Professores />} />
              <Route path="/cursos" element={<Cursos />} />
              <Route path="/cursos/:id" element={<CursoDetails />} />
              
              {/* ================================================================= */}
              {/* *** ROTAS DE CONFIGURAÇÃO CORRIGIDAS (NÃO ANINHADAS) *** */}
              {/* ================================================================= */}
              <Route path="/configuracao" element={<Configuracao />} />
              <Route path="/configuracao/uploadlogo" element={<UploadLogo />} />
              <Route path="/configuracao/usuarios" element={<Usuarios />} />
              <Route path="/configuracao/temas" element={<Temas />} />
              <Route path="/configuracao/minicursos" element={<MinicursoManager />} />
              <Route path="/configuracao/bot" element={<BotControl />} />
              <Route path="/configuracao/ia" element={<TreinamentoIA />} />
              <Route path="/configuracao/administracao" element={<Administracao />} />
              <Route path="/configuracao/boletim" element={<BoletimEditor />} />
              
              <Route path="*" element={<Navigate to="/" />} /> {/* Redireciona para a Home se a rota não for encontrada */}
            </Routes>
          </>
        ) : (
          <Login user={user} />
        )}

        {/* <-- NOVO: Adicionar o ToastContainer aqui --> */}
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={theme} // Opcional: faz o toast acompanhar o tema do seu app
        />
      </div>
    </Router>
  );
}

export default App;
